import { useQuery } from "@apollo/client";
import { useState } from "react";
import { SETTINGS } from "modules/worksheet/api";
import WorksheetProducts from "modules/worksheet/WorksheetProducts";
import { Grid, Tabs, Tab } from "@mui/material";
import MDAlert from "components/MDAlert";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import useGetOrganizationProductType from "hooks/organization/product-types/useGetOrganizationProductType";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import OrganizationProductTypeProducts from "modules/OrganizationProductTypes/OrganizationProductTypeProducts";
import { Link, useParams } from "react-router-dom";
import parseGraphQLError from "utils/graphQL/parseGraphQLError";
import { getRoute } from "utils/routing";

export default function OrganizationProductTypePage() {
  const { productTypeId } = useParams();
  const { data: settings } = useQuery(SETTINGS);
  const [chosen, setChosen] = useState<string | null>(null);
  const enabled = settings?.worksheetSettings.enabled;
  const tab = enabled ? chosen ?? settings?.worksheetSettings.method ?? "production" : "production";
  const { data: productType, error } = useGetOrganizationProductType({ id: productTypeId });

  return (
    <DashboardPage>
      <MDBox mb={6}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={6}>
            <MDTypography variant="h4" fontWeight="medium">
              {productType?.name ?? ""}
            </MDTypography>
          </Grid>
          <Grid item xs={12} md={6} display="flex" justifyContent="flex-end">
            {tab === "production" && (
              <MDButton
                component={Link}
                type="button"
                to={getRoute("product-types.products.create", [["productTypeId", productTypeId]])}
                variant="gradient"
                color="info"
              >
                Create Product
              </MDButton>
            )}
          </Grid>
        </Grid>
        {error && (
          <Grid item xs={12}>
            <MDAlert color="error">{parseGraphQLError(error)}</MDAlert>
          </Grid>
        )}
      </MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {enabled && (
            <Tabs
              value={tab}
              onChange={(_, value) => setChosen(value)}
              sx={{ mb: 3 }}
              aria-label="Product estimating method"
            >
              <Tab label="Worksheet" value="worksheet" />
              <Tab label="Production-based" value="production" />
            </Tabs>
          )}
          {tab === "worksheet" ? (
            <WorksheetProducts productTypeId={productTypeId} />
          ) : (
            <OrganizationProductTypeProducts id={productTypeId} />
          )}
        </Grid>
      </Grid>
    </DashboardPage>
  );
}
